export default "__VITE_PUBLIC_ASSET__e4273fb7__"